import type { EventCard } from "@tih/shared";
import { useReveal } from "../hooks/useReveal";
import { CopyText } from "./CopyText";

const FALLBACK_CARDS: EventCard[] = [
  { num: "01", k: "Doors", v: "9:00 PM", note: "Arrive early — seating is first come." },
  { num: "02", k: "Entry", v: "Free", note: "An offering will be taken for the ministry." },
  { num: "03", k: "Duration", v: "8 Hours", note: "Continuous worship through the night." },
  { num: "04", k: "Stream", v: "Worldwide", note: "Join from anywhere. Free to watch." },
];

export function EventDetails({ cards = FALLBACK_CARDS }: { cards?: EventCard[] }) {
  const ref = useReveal<HTMLElement>();
  return (
    <section className="section section-event" id="event" ref={ref}>
      <div className="sec-eyebrow">
        <em>
          <CopyText path="eventSection.eyebrow" as="span" />
        </em>
      </div>
      <h2 className="sec-title" style={{ whiteSpace: "pre-line" }}>
        <CopyText path="eventSection.title" as="span" />
      </h2>
      <p className="sec-lede">
        <CopyText path="eventSection.lede" as="span" />
      </p>
      <div className="event-cards">
        {cards.map((c) => (
          <div className="ev-card" key={c.num}>
            <div className="ev-num">{c.num}</div>
            <div className="ev-k">{c.k}</div>
            <div className="ev-v">{c.v}</div>
            <div className="ev-note">{c.note}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
